import React from "react";
import { CheckIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { Countdown } from "../Countdown";
import { finalIncludes } from "../../data/content";
import { images } from "../../data/links";
export function FinalCTASection() {
  return <section className="bg-ink px-4 pb-28 pt-16 sm:pb-24 sm:pt-24" data-id="element-161" data-mp="1bky00wtj9n7q">
      <div className="mx-auto max-w-5xl text-center" data-id="element-162" data-mp="1bjmwmy402hh5">
        <p className="text-sm font-extrabold uppercase text-brand" data-id="element-163" data-mp="1pk7dvpu9o58j">Ready to bring more structure to your ClinCheck reviews?</p>
        <h2 className="mt-3 text-balance font-display text-[32px] font-extrabold leading-[1.1] text-white sm:text-5xl" data-id="element-164" data-mp="1kkuw3ji95oct">
          Stop relying on memory alone. <span className="text-brand" data-id="element-165" data-mp="1ubfnomzidsm8">Start following a structured review process.</span>
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-lg leading-relaxed text-white/75" data-id="element-166" data-mp="28b71onq0z908">
          You don't need another complicated system. You need practical resources that help you organize your clinical
          questions, document your observations, and review treatment plans more systematically.
        </p>

        <div className="mt-10 grid items-center gap-8 lg:grid-cols-2" data-id="element-167" data-mp="1lo0dgu10j9ph">
          <img src={images.hero} alt="The ClinCheck Blueprint complete package" className="mx-auto w-full max-w-lg" data-id="element-168" data-mp="1lqd1noxd6gaz" />
          <div className="rounded-3xl bg-navy p-6 text-left ring-2 ring-brand/40 sm:p-8" data-id="element-169" data-mp="1vmg6j2jlot1m">
            <p className="text-sm font-extrabold uppercase text-gold" data-id="element-170" data-mp="20lsszm6k7y3o">Your complete package includes:</p>
            <ul className="mt-4 space-y-3" data-id="element-171" data-mp="24n5yfv5qpza2">
              {finalIncludes.map(i => <li key={i} className="flex items-center gap-3 text-[17px] font-semibold text-white" data-id="element-172" data-mp="29e4dkrezsrbq">
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-cta" data-id="element-173" data-mp="2ed7imbuz2xjp">
                    <CheckIcon className="h-4 w-4 text-ink" strokeWidth={3.5} aria-hidden="true" data-id="element-174" data-mp="2jck7t39bggpg" />
                  </span>
                  {i}
                </li>)}
            </ul>
            <div className="mt-6 border-t border-white/10 pt-6 text-center" data-id="element-175" data-mp="1ymzs442iphzl">
              <p className="text-base font-bold text-white/60" data-id="element-176" data-mp="1ykwrkq3qo6gm">
                Regular value <span className="line-through" data-id="element-177" data-mp="1tpzl9qxugb7f">$264</span>
              </p>
              <p className="font-display text-6xl font-extrabold text-cta" data-id="element-178" data-mp="28dugbdzbqrno">$27 USD</p>
              <p className="mt-1 text-sm font-semibold text-white/70" data-id="element-179" data-mp="23m2kop1b9vqo">One-time payment · Digital download · No recurring fees</p>
            </div>
          </div>
        </div>

        <div className="mt-10" data-id="element-180" data-mp="2cewgpy4z99r8">
          <CTAButton label="Yes, I want the ClinCheck Blueprint™" sublabel="Instant access · 7-day guarantee" data-id="element-181" data-mp="2cdmin8y4k1kl" />
        </div>
        <Countdown tone="dark" data-id="element-182" data-mp="2rb5eev97zf1j" />
      </div>
    </section>;
}